import React from "react";
import PageHeader from "../PageHeader";
import Projects from "../Projects";
import Publications from "../Publications";
import { RichText } from "prismic-reactjs";
import { connect } from "react-redux";
import {
  fetchWhatWeDoPage
} from "../../store/actions";
import Loader from "../Loader";
import { linkResolver } from "../../prismic-configuration";

class WhatWeDo extends React.Component {
  componentDidMount() {
    this.props.fetchWhatWeDoPage();
  }

  render() {
    const { page } = this.props;

    if (page.settled) {
    return (
      <div>
        <PageHeader title={RichText.asText(page.entity.data.title)} />

        <div className="container pt-5 pb-5">
          {page.entity.data.short_description && (
            <div className="row mb-5 text-center">
              <div className="col-12 col-md-8 offset-md-2">
                {RichText.render(page.entity.data.short_description, linkResolver)}
              </div>
            </div>
          )}

          <div className="row mb-5">
            <div className="col-12">
              <h2 className="mb-3">HOW WE WORK</h2>
              <Projects prismicCtx={this.props.prismicCtx} />
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-12">
              <h2 className="mb-3">OUR PRIORITIES</h2>
              <Publications prismicCtx={this.props.prismicCtx} />
            </div>
          </div>
        </div>
      </div>
    );
    } else {
      return <Loader />;
    }    
  }
}

const mapStateToProps = state => ({
  page: state.whatWeDo,
});

export default connect(mapStateToProps, {
  fetchWhatWeDoPage,
})(WhatWeDo);



// WEBPACK FOOTER //
// ./src/components/pages/WhatWeDo.js